module.exports = __webpack_public_path__ + "static/15-e88fded194d1b5c1f459f271dbac9381.png";